'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

exports.__esModule = true;
exports['default'] = reducer;
exports.login = login;
exports.logout = logout;
var LOGIN = '@@auth/LOGIN';
var LOGIN_SUCCESS = '@@auth/LOGIN_SUCCESS';
exports.LOGIN_SUCCESS = LOGIN_SUCCESS;
var LOGIN_FAIL = '@@auth/LOGIN_FAIL';
var LOGOUT = '@@auth/LOGOUT';
var LOGOUT_SUCCESS = '@@auth/LOGOUT_SUCCESS';
var LOGOUT_FAIL = '@@auth/LOGOUT_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case LOGIN:
      return _extends({}, state, {
        loggingIn: true
      });
    case LOGIN_SUCCESS:
      return _extends({}, state, {
        loggingIn: false,
        isLoggedIn: true,
        identity: action.result.auth.identity
      });
    case LOGIN_FAIL:
      return _extends({}, state, {
        loggingIn: false,
        isLoggedIn: false,
        loginError: action.error.message
      });
    case LOGOUT:
      return _extends({}, state, {
        loggingOut: true
      });
    case LOGOUT_SUCCESS:
      return _extends({}, state, {
        loggingOut: false,
        isLoggedIn: false,
        identity: null
      });
    case LOGOUT_FAIL:
      return _extends({}, state, {
        loggingOut: false,
        logoutError: action.error
      });
    default:
      return state;
  }
}

function login(values) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.call('login', _extends({}, values), { progress: true });
    }
  };
}

function logout() {
  return {
    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: function promise(client) {
      return client.call('logout', null, { progress: true });
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/auth.js
 ** module id = 130
 ** module chunks = 2
 **/